import { TransientAccessCredEventNames } from '../../constants/transient_access_cred_constants';
import { ClearTransientAccessCredCommand } from '../../commands/clear_transient_access_cred_command';
import { SaveTransientAccessCredCommand } from '../../commands/save_transient_access_cred_command';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { ITransientAccessCred } from '../../builders/transient_access_cred_builder';
interface IAccessCredFormSubmitOutput {
  detail: {
    value: ITransientAccessCred;
  };
}

class TransientAccessCredForm {
  constructor(
    private ngComponentCommunicatorService: CommunicatorService,
    private saveTransientAccessCredCommand: SaveTransientAccessCredCommand,
    private clearTransientAccessCredCommand: ClearTransientAccessCredCommand
  ) {}

  clearAccessCred() {
    return this.clearTransientAccessCredCommand().then(() =>
      this.ngComponentCommunicatorService.publish(TransientAccessCredEventNames.CRED_CLEARED)
    );
  }

  onTransientAccessFormSubmitted($event: IAccessCredFormSubmitOutput) {
    this.saveTransientAccessCredCommand($event.detail.value)
      .then(() => this.ngComponentCommunicatorService.publish(TransientAccessCredEventNames.NEW_CRED_SAVED))
      .catch((e) => this.clearAccessCred());
  }

  onClickCancelButton() {
    return this.clearAccessCred().then(() =>
      this.ngComponentCommunicatorService.publish(TransientAccessCredEventNames.CRED_FORM_ENTRY_CANCELLED)
    );
  }
}

angular.module('capability-ng-scheduler').component('transientAccessCredForm', {
  templateUrl:
    'capability-ng-scheduler/src/prevent_transient_access/components/transient_access_cred_form/transient_access_cred_form.html',
  bindings: {},
  controller: TransientAccessCredForm
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/prevent_transient_access/components/transient_access_cred_form/transient_access_cred_form.ts